import { config } from '@v4/config';
import { getJsonDataFromScript } from '@v4/common/utils/json';

/**
 * Get locale from lang attribute in the HTML tag
 *
 * @returns {string} locale value, by default it's `en`
 */
export const getLocale = () => (document.documentElement.lang || config.DEFAULT_LANG).substr(0, 2);

/**
 * Get locale messages from script block with type 'application/json'
 *
 * @returns {object} messages
 */
export const getLocaleMessages = (key = 'DrivekDictionary') => {
    const selector = 'script#drivek-translations[type="application/json"]';
    let messages;

    if (document.querySelector(selector)) {
        messages = getJsonDataFromScript(selector)[key];
    }

    return messages;
};
